/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  AppBar,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";

import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { InputNumber } from "primereact/inputnumber";
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  deleteSelectedVehicleDocument,
  getParameterListName,
  getVehicleById,
  getVehicleDocument,
  saveVehicle,
  updateVehicleByID,
} from "utils/api";
import { appConstants } from "utils/appConstants";
import {
  blank,
  generateDataList,
  getScreenRight,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let fetchedvehicles;

function EditVehicle() {
  const { id } = useParams();
  const [table, setTable] = useState("vehicleInformation");
  const [showDocuments, setshowDocumentsTable] = useState(false);
  const [showVehicleInfoTable, setshowVehicleInfoTable] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [screenName, setScreenName] = useState("Edit Vehicle");
  // const [controller, dispatch] = useMaterialUIController();
  // const { sidenavColor, darkMode } = controller;
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [selectedDate, setSelectedDate] = useState("");
  const [vehicleCategoryErr, setVehicleCategoryErr] = useState(false);
  const [registrationNumberErr, setRegistrationNumberErr] = useState(false);
  const [vehicleMakeModelErr, setVehicleMakeModelErr] = useState(false);
  const [vehicleOwnerErr, setVehicleOwnerErr] = useState(false);
  const [vehicleManufacturingYearErr, setVehicleManufacturingYearErr] =
    useState(false);
  const [vinChassisNumberErr, setVinChassisNumberErr] = useState(false);
  const [engineNumberErr, setEngineNumberErr] = useState(false);
  const [equipmentIDErr, setEquipmentIDErr] = useState(false);
  const [tareWeightErr, setTareWeightErr] = useState(false);
  const [gcmErr, setGcmErr] = useState(false);
  const [maxWeightErr, setMaxWeightErr] = useState(false);
  const [maxVolumeErr, setMaxVolumeErr] = useState(false);

  const [locationErr, setLocationErr] = useState(false);
  const [expiryDateErr, setExpiryDateErr] = useState(false);
  const [trailerTypeErr, setTrailerTypeErr] = useState(false);
  const [slotLengthErr, setSlotLengthErr] = useState(false);
  const [slotBreadthErr, setSlotBreadthErr] = useState(false);
  const [slotHeightErr, setSlotHeightErr] = useState(false);
  const [palletCountErr, setPalletCountErr] = useState(false);
  const [mezzPalletCountErr, setMezzPalletCountErr] = useState(false);
  const [mezzHeightErr, setMezzHeightErr] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");

  const [viewImage, setViewImage] = useState();
  const [showViewImageFlag, setShowViewImageModalFlag] = useState(false);
  const [category, setCategory] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [uiOpen, setUiOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [values, setValues] = React.useState({
    vehicleCategory: "",
    registrationNumber: "",
    vehicleMakeModel: "",
    vehicleOwner: "",
    vehicleManufacturingYear: "",
    vinChassisNumber: "",
    vehicleType: "Tautliner",
    engineNumber: "",
    equipmentID: "",
    tareWeight: "",
    gcm: "",
    vehicleStatus: "Active",
    palletCount: "",
    temperatureType: " ",
    location: "",
    registrationExpiryDate: "",
    trailerType: "",
    belowPalletCount: "",
    upperPalletCount: "",
    notes: "",
    maxWeight: "",
    maxVolume: "",
    mezzHeight: "",
    slotLength: "",
    slotBreadth: "",
    slotHeight: "",
    searchParameter: "",
    mezzPalletCount: "",
    searchParameterList: [
      "vehicleCategory",
      "registrationNumber",
      "equipmentID",
      "location",
      "registrationExpiryDate",
      "vehicleStatus",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });
  let mandateFlag = false;

  const [values1, setValues1] = React.useState({
    documentName: "",
    documentType: "",
    documentFileName: "",
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
    filterValues: "",
    searchParameterList: ["documentType", "documentName", "uploadedDate"],
  });

  async function getRight() {
    let right = await getScreenRight("Vehicles");
    if (right === "Full Access") setDisableColor(false);
    else setDisableColor(true);
  }

  useEffect(() => {
    categoryData.map((cat) => {
      if (cat._id === values.vehicleCategory) {
        setUiOpen(cat.parameterListName);
      }
    });
  }, [values.vehicleCategory]);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleChange1 = (prop) => (event) => {
    if (values.tareWeight !== 0 || values.tareWeight !== null) {
      setValues({ ...values, [prop]: event.target.value });
    } else {
      setValues({ ...values, [prop]: event.target.value });
    }
  };
  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchVehicleDocument();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values1.sortingType = value;
    values1.sortingField = type;
  };
  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) setSelectedRows([]);
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values._id = [];
        for (let element of selectedRows) {
          values._id.push(element._id);
        }
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error">
        Delete
      </MDButton>
    );
  }, [selectedRows, toggleCleared]);
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) setTitle(" ");
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  useEffect(() => {
    if (values.trailerType !== "Mezz") {
      values.mezzHeight = 0;
      values.mezzPalletCount = 0;
    }
  }, [values.trailerType]);

  useEffect(() => {
    (async () => {
      await fetchVehicleCategory();
      getRight();
      if (id !== undefined) {
        values._id = id;
        await getVehicleById(
          values,
          (data) => {
            if (data.Result_Output.length > 0) {
              fetchedvehicles = data.Result_Output[0];
              fetchedvehicles.registrationExpiryDate = new Date(
                fetchedvehicles.registrationExpiryDate
              );
              handleDateChange(fetchedvehicles.registrationExpiryDate);
              setValues(fetchedvehicles);
            }
          },
          dispatch
        );
      }
    })();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "documents") {
      setTable("documents");
    }
    if (table === "vehicleInformation") {
      setshowVehicleInfoTable(true);
      setshowDocumentsTable(false);
      setTabValue(0);
    } else if (table === "documents") {
      setshowVehicleInfoTable(false);
      setshowDocumentsTable(true);
      setTabValue(1);
      fetchVehicleDocument();
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  const handleCancelImage = (name) => (event) => {
    setShowViewImageModalFlag(false);
  };

  const showImg = (img) => {
    console.log("IMAGE===", img);
    setShowViewImageModalFlag(true);
    setViewImage(appConstants.baseURL + "vehicle/viewFile?fileName=" + img);
  };

  const handleDateChange = (date) => {
    values.registrationExpiryDate = date;
    setSelectedDate(date);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = [];
    values._id.push(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteDocument();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const deleteDocument = async () => {
    sessionStorage.setItem("PARA_TABLE", "documents");
    deleteSelectedVehicleDocument(
      values,
      (data) => {
        fetchVehicleDocument();
        setToggleCleared(true);
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };
  const currentYear = new Date().getFullYear();

  const clearErrorStates = () => {
    setVehicleCategoryErr(false);
    setRegistrationNumberErr(false);
    setVehicleMakeModelErr(false);
    setVehicleOwnerErr(false);
    setVehicleManufacturingYearErr(false);
    setVinChassisNumberErr(false);
    setEngineNumberErr(false);
    setEquipmentIDErr(false);
    setTareWeightErr(false);
    setGcmErr(false);
    setLocationErr(false);
    setExpiryDateErr(false);
    setTrailerTypeErr(false);
    setSlotLengthErr(false);
    setSlotBreadthErr(false);
    setSlotHeightErr(false);
    setMaxVolumeErr(false);
    setMezzHeightErr(false);
    setMezzPalletCountErr(false);
    setPalletCountErr(false);
    setMaxWeightErr(false);
    setMaxWeightErr(false);
  };
  const updateVehicle = () => {
    mandateFlag = false;
    clearErrorStates();
    mandateFlag =
      validateField(values.vehicleCategory, setVehicleCategoryErr) ||
      mandateFlag;
    mandateFlag =
      validateField(values.registrationNumber, setRegistrationNumberErr) ||
      mandateFlag;
    mandateFlag =
      validateField(values.vehicleMakeModel, setVehicleMakeModelErr) ||
      mandateFlag;
    mandateFlag =
      validateField(values.vehicleOwner, setVehicleOwnerErr) || mandateFlag;
    if (values.vehicleManufacturingYear.toString().trim() === "") {
      setVehicleManufacturingYearErr(
        "Vehicle Manufacturing Year can't be blank"
      );
      mandateFlag = true;
    } else if (values.vehicleManufacturingYear.toString().trim().length < 4) {
      setVehicleManufacturingYearErr(
        "vehicle Manufacturing Year should contain at least 4 numeric"
      );
      mandateFlag = true;
    } else setVehicleManufacturingYearErr(false);
    if (parseInt(values.vehicleManufacturingYear) > currentYear) {
      swal({
        title: "Cannot add Year more then current Year",
        text: " ",
        icon: "error",
        color: "red",
        button: false,
        timer: 2000,
      });
      mandateFlag = true;
      return;
    }
    mandateFlag =
      validateField(values.vinChassisNumber, setVinChassisNumberErr) ||
      mandateFlag;

    // if (uiOpen !== "Trailer") {
    mandateFlag =
      validateField(values.engineNumber, setEngineNumberErr) || mandateFlag;
    mandateFlag =
      validateField(values.equipmentID, setEquipmentIDErr) || mandateFlag;
    mandateFlag =
      validateField(values.tareWeight, setTareWeightErr) || mandateFlag;
    mandateFlag = validateField(values.gcm, setGcmErr) || mandateFlag;
    mandateFlag = validateField(values.location, setLocationErr) || mandateFlag;
    mandateFlag =
      validateField(values.registrationExpiryDate, setExpiryDateErr) ||
      mandateFlag;
    // }
    if (uiOpen === "Trailer") {
      mandateFlag =
        validateField(values.trailerType, setTrailerTypeErr) || mandateFlag;
      mandateFlag =
        validateField(values.slotLength, setSlotLengthErr) || mandateFlag;
      mandateFlag =
        validateField(values.slotBreadth, setSlotBreadthErr) || mandateFlag;
      mandateFlag =
        validateField(values.slotHeight, setSlotHeightErr) || mandateFlag;
      mandateFlag =
        validateField(values.maxVolume, setMaxVolumeErr) || mandateFlag;
      mandateFlag =
        validateField(values.maxWeight, setMaxWeightErr) || mandateFlag;
      mandateFlag =
        validateField(values.palletCount, setPalletCountErr) || mandateFlag;
      if (values.trailerType === "Mezz") {
        mandateFlag =
          validateField(values.mezzPalletCount, setMezzPalletCountErr) ||
          mandateFlag;
        mandateFlag =
          validateField(values.mezzHeight, setMezzHeightErr) || mandateFlag;
      }
    }
    if (mandateFlag) {
      return;
    }
    const apiFunction = id !== undefined ? updateVehicleByID : saveVehicle;
    apiFunction(
      values,
      (data) => {
        if (data.Result_Status) {
          showResMsg(
            id === undefined ? genericMessage.added : genericMessage.updated,
            1000,
            data.Result_Status,
            navigate,
            "/vehicles"
          );
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      },
      dispatch
    );
  };
  const fetchVehicleDocument = async () => {
    values1.vehicleID = id;
    getVehicleDocument(
      values1,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  let fetchVehicleCategory = async () => {
    getParameterListName(async (data) => {
      if (data.Result_Output.length > 0) {
        for (let parameter of data.Result_Output) {
          if (parameter.parameterCode === "VC") {
            parameter.parameterList.sort(
              (a, b) => a.parameterListSequence - b.parameterListSequence
            );
            setCategoryData(parameter.parameterList);
            setCategory(
              await generateDataList(
                parameter.parameterList,
                "_id",
                "parameterListName"
              )
            );
          }
        }
      }
    });
  };
  const vehicleInfo = (
    <>
      {showVehicleInfoTable && (
        <>
          <MDBox mt={4} mb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} spacing={6}>
                <Card sx={{ boxShadow: "none" }}>
                  <MDBox pt={2} px={3}>
                    <Grid container columnSpacing={5}>
                      <Grid item xs={12} lg={3}>
                        <MDBox mb={4} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Vehicle Category
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              style={{ minHeight: "44.11px" }}
                              label="Vehicle Category"
                              onChange={handleChange("vehicleCategory")}
                              value={values.vehicleCategory}
                            >
                              <MenuItem value="">Select..</MenuItem>
                              {category}
                            </Select>
                            {vehicleCategoryErr ? (
                              <span style={errMsg}>
                                Vehicle Category can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </FormControl>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Registration Number"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 20,
                              }}
                              value={values.registrationNumber}
                              onChange={handleChange("registrationNumber")}
                            />
                            {registrationNumberErr ? (
                              <span style={errMsg}>
                                Registration Number can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Vehicle Make Model"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 20,
                              }}
                              pattern="^[a-zA-Z0-9]+$"
                              value={values.vehicleMakeModel}
                              onChange={handleChange("vehicleMakeModel")}
                            />
                            {vehicleMakeModelErr ? (
                              <span style={errMsg}>
                                Vehicle Make Model can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox mb={4} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Vehicle Owner
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              style={{ minHeight: "44.11px" }}
                              label="Vehicle Owner"
                              onChange={handleChange("vehicleOwner")}
                              value={values.vehicleOwner}
                            >
                              <MenuItem value="Contractor">Contractor</MenuItem>
                              <MenuItem value="Lease">Lease</MenuItem>
                              <MenuItem value="Company">Company</MenuItem>
                            </Select>
                            {vehicleOwnerErr ? (
                              <span style={errMsg}>
                                Vehicle Owner can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </FormControl>
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Vehicle Manufacturing Year"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[0-9]+$",
                                maxLength: 4,
                              }}
                              value={values.vehicleManufacturingYear}
                              onChange={handleChange(
                                "vehicleManufacturingYear"
                              )}
                            />
                            {vehicleManufacturingYearErr ? (
                              <span style={errMsg}>
                                {vehicleManufacturingYearErr}
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="VIN/Chassis Number"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 20,
                              }}
                              value={values.vinChassisNumber}
                              onChange={handleChange("vinChassisNumber")}
                            />
                            {vinChassisNumberErr ? (
                              <span style={errMsg}>
                                VIN/Chassis Number can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label={`Engine Number ${
                                uiOpen === "Trailer" ? "(Optional)" : ""
                              }`}
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 20,
                              }}
                              value={values.engineNumber}
                              onChange={handleChange("engineNumber")}
                            />
                            {engineNumberErr ? (
                              <span style={errMsg}>
                                Engine Number can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Equipment ID"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 20,
                              }}
                              value={values.equipmentID}
                              onChange={handleChange("equipmentID")}
                            />
                            {equipmentIDErr ? (
                              <span style={errMsg}>
                                Equipment ID can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox mb={4} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Vehicle Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              style={{ minHeight: "44.11px" }}
                              label="Vehicle Type"
                              onChange={handleChange("vehicleType")}
                              value={values.vehicleType}
                            >
                              <MenuItem value="Tautliner">Tautliner</MenuItem>
                              <MenuItem value="Single Zone Refrigerated">
                                Single Zone Refrigerated
                              </MenuItem>
                              <MenuItem value="Dual Zone Refrigerated">
                                Dual Zone Refrigerated
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              label="Tare Weight (Ton)"
                              variant="outlined"
                              fullWidth
                              className="tareWeight"
                              style={{
                                height: "44.11px",
                                alignItems: "center",
                                display: "flex",
                              }}
                              InputLabelProps={
                                values.tareWeight && { shrink: true }
                              }
                              InputProps={{
                                inputComponent: InputNumber, // Use your InputNumber component here
                                inputProps: {
                                  inputStyle: {
                                    outline: "white",
                                    width: "100%",
                                    height: "100%",
                                    marginTop: "-10px",
                                    border: "none",
                                  },
                                  // inputClassName: darkMode ? "tareWeight2" : "",
                                  minFractionDigits: 2,
                                  maxFractionDigits: 2,
                                  maxLength: 7,
                                  value: values.tareWeight,
                                  onValueChange: handleChange1("tareWeight"),
                                },
                              }}
                            />

                            {tareWeightErr ? (
                              <span style={errMsg}>
                                Tare Weight can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="GCM"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9]+$",
                                maxLength: 15,
                              }}
                              onChange={handleChange("gcm")}
                              value={values.gcm}
                            />
                            {gcmErr ? (
                              <span style={errMsg}>GCM can't be blank</span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox mb={4} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Temperature Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              style={{ minHeight: "44.11px" }}
                              label="Temperature Type"
                              onChange={handleChange("temperatureType")}
                              value={values.temperatureType}
                            >
                              <MenuItem value=" ">None</MenuItem>
                              <MenuItem value="Chiller">Chiller</MenuItem>
                              <MenuItem value="Freezer">Freezer</MenuItem>
                              <MenuItem value="Chiller & Freezer">
                                Chiller & Freezer
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Location"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9 ]+$",
                                maxLength: 50,
                              }}
                              onChange={handleChange("location")}
                              value={values.location}
                            />
                            {locationErr ? (
                              <span style={errMsg}>
                                Location can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <PickDate
                              label="Registration Expiry Details"
                              selected={selectedDate}
                              onChange={handleDateChange}
                            />
                            {expiryDateErr ? (
                              <span style={errMsg}>
                                Registration Expiry Date can't be blank
                              </span>
                            ) : (
                              ""
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Vehicle Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                style={{ minHeight: "44.11px" }}
                                label="Vehicle Status"
                                onChange={handleChange("vehicleStatus")}
                                value={values.vehicleStatus}
                              >
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive </MenuItem>
                              </Select>
                            </FormControl>
                          </MDBox>
                        </MDBox>
                      </Grid>

                      {uiOpen === "Trailer" && (
                        <>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <FormControl fullWidth>
                                  <InputLabel id="demo-simple-select-label">
                                    Trailer Type
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    style={{ minHeight: "44.11px" }}
                                    label="Trailer Type"
                                    value={values.trailerType}
                                    onChange={handleChange("trailerType")}
                                  >
                                    <MenuItem value="Normal">Normal</MenuItem>
                                    <MenuItem value="Mezz">Mezz</MenuItem>
                                  </Select>
                                  {trailerTypeErr ? (
                                    <span style={errMsg}>
                                      Trailer Type can't be blank
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </FormControl>
                              </MDBox>
                            </MDBox>
                          </Grid>
                          {/* {(values.trailerType === 'Single Decker' || values.trailerType === 'Double Decker') && ( */}
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Slot Length (m3)"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.slotLength}
                                  onChange={handleChange("slotLength")}
                                />
                                {slotLengthErr ? (
                                  <span style={errMsg}>
                                    Slot Length can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Slot Width (mm)"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.slotBreadth}
                                  onChange={handleChange("slotBreadth")}
                                />
                                {slotBreadthErr ? (
                                  <span style={errMsg}>
                                    Slot Width can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Slot Height (m3)"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.slotHeight}
                                  onChange={handleChange("slotHeight")}
                                />
                                {slotHeightErr ? (
                                  <span style={errMsg}>
                                    Slot Height can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Max Weight (kg)"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.maxWeight}
                                  onChange={handleChange("maxWeight")}
                                />
                                {maxWeightErr ? (
                                  <span style={errMsg}>
                                    Max Weight can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Max Volume (m3)"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.maxVolume}
                                  onChange={handleChange("maxVolume")}
                                />
                                {maxVolumeErr ? (
                                  <span style={errMsg}>
                                    Max Volume can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Pallet Count"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    pattern: "^[0-9 ]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.palletCount}
                                  onChange={handleChange("palletCount")}
                                />
                                {palletCountErr ? (
                                  <span style={errMsg}>
                                    Pallet Count can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Mezz Pallet Count"
                                  variant="outlined"
                                  fullWidth
                                  disabled={
                                    values.trailerType === "Mezz" ? false : true
                                  }
                                  inputProps={{
                                    pattern: "^[0-9 ]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.mezzPalletCount}
                                  onChange={handleChange("mezzPalletCount")}
                                />
                                {mezzPalletCountErr ? (
                                  <span style={errMsg}>
                                    Mezz Pallet Count can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <MDBox mb={4} xs={12}>
                                <TextField
                                  type="text"
                                  label="Mezz Height"
                                  variant="outlined"
                                  fullWidth
                                  disabled={
                                    values.trailerType === "Mezz" ? false : true
                                  }
                                  inputProps={{
                                    pattern: "^[0-9 ]+$",
                                    maxLength: 20,
                                  }}
                                  value={values.mezzHeight}
                                  onChange={handleChange("mezzHeight")}
                                />
                                {mezzHeightErr ? (
                                  <span style={errMsg}>
                                    Mezz Height can't be blank
                                  </span>
                                ) : (
                                  ""
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} lg={6}>
                        <MDBox component="form" role="form">
                          <MDBox mb={4} xs={12}>
                            <TextField
                              type="text"
                              label="Notes (Optional)"
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                pattern: "^[a-zA-Z0-9 ]+$",
                                maxLength: 500,
                              }}
                              onChange={handleChange("notes")}
                              value={values.notes}
                            />
                            {/* {notesErr ? <span style={errMsg}>Notes can't be blank</span> : ""} */}
                          </MDBox>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
            <Grid
              container
              mt={2}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
            >
              <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                <Link to={"/vehicles"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                  >
                    Cancel
                  </MDButton>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                <MDButton
                  onClick={disableColor ? blank : updateVehicle}
                  rel="noreferrer"
                  variant="gradient"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                  fullWidth
                >
                  {id !== undefined ? <>Update</> : <>Save</>}
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </>
  );

  let columns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "documentName",
    },
    {
      name: "Document Type",
      selector: (row) => row.documentType,
      sortable: true,
      sortField: "documentType",
    },
    {
      name: "Uploaded Date Time",
      selector: (row) => row.uploadedDateString,
      sortable: true,
      sortField: "uploadedDate",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item style={{ marginLeft: "-20px" }}>
              <TimelineItem
                color="info"
                icon="visibility"
                title="View"
                onClick={() => showImg(row.docNameAndID.documentFileName)}
              />
            </Grid>
            <Grid item>
              <Link
                to={`/vehicles/editVehicleDocument/${row.docNameAndID.docID}?emp=${values._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row.docNameAndID.docID)}
                title="Delete"
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchVehicleDocument();
  }, [values1.page, values1.limit, values1.sortingType]);
  const documents = (
    <>
      {showDocuments && (
        <>
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={3}
            pt={3}
            pb={3}
            gap={2}
            px={2.2}
          >
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values1.filterValues}
                onChange={(e) =>
                  setValues1({ ...values1, filterValues: e.target.value })
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchVehicleDocument}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={`/vehicles/addVehicleDocument/${values._id}`}>
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              contextActions={contextActions}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {vehicleInfo}
        {documents}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container>
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": {
                    color: "#fff !important",
                    background: `${barColor} !important`,
                  },
                  ".MuiTabs-indicator": {
                    background: `${barColor} !important`,
                  },
                }}
              >
                <Tab
                  onClick={() => setTable("vehicleInformation")}
                  label="Vehicle Information"
                />
                <Tab
                  disabled={id !== undefined ? false : true}
                  onClick={() => setTable("documents")}
                  label="Documents"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {renderTable()}
      </Card>
      <ShowProfile
        open={showViewImageFlag}
        fileName={viewImage}
        closeModalClick={handleCancelImage("closeModalClick")}
        // handleDelete={handleDelete}
        // handleCancel={handleCancel("handleCancel")}
      />

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default EditVehicle;
